// @ts-nocheck
import React, { FC } from 'react';

import { Container, Row, Col } from 'crehana-ui/GridV2';
import CheckedUser from 'crehana-icons/pictograms/CheckedUser';
import Discount from 'crehana-icons/pictograms/Discount';
import Gift from 'crehana-icons/pictograms/Gift';

import useCLTranslation from 'Jsx/CouponLanding/hooks/useCLTranslation';

interface StepsProps {
  couponCode: string;
}

const Steps: FC<StepsProps> = ({ couponCode }) => {
  const { t } = useCLTranslation();

  return (
    <section className="pt-24 pb-32 sm:pt-48 sm:pb-72">
      <Container>
        <Row>
          <Col xs={8} sm="auto" offset={{ xs: 2, sm: 0 }}>
            <h3 className="font-h3 mb-32 lg:mb-48 text-center">
              {t('STEPS_TITLE')}
            </h3>
          </Col>
        </Row>

        <Row>
          <Col
            xs={8}
            sm={4}
            offset={{ xs: 2, sm: 0 }}
            className="text-center sm:text-left mb-32 sm:m-0"
          >
            <div className="relative inline-block mb-20 sm:mb-40">
              <CheckedUser size={80} />
              <div className="absolute bottom-0 left-0 right-0 -z-1 flex justify-center">
                <div className="rounded-full bg-green-main w-52 h-52" />
              </div>
            </div>
            <h4 className="font-h4 mb-16">{t('STEPS_1_TITLE')}</h4>
            <p className="font-body3">{t('STEPS_1_DESCRIPTION')}</p>
          </Col>

          <Col
            xs={8}
            sm={4}
            offset={{ xs: 2, sm: 0 }}
            className="text-center sm:text-left mb-32 sm:m-0"
          >
            <div className="relative inline-block mb-20 sm:mb-40">
              <Discount size={80} />
              <div className="absolute bottom-0 right-0 rounded-full bg-yellow-main w-52 h-52 -z-1" />
            </div>
            <h4 className="font-h4 mb-16">{t('STEPS_2_TITLE')}</h4>
            <p className="font-body3">
              {t('STEPS_2_DESCRIPTION')}
              <br />
              {couponCode}
            </p>
          </Col>

          <Col
            xs={8}
            sm={4}
            offset={{ xs: 2, sm: 0 }}
            className="text-center sm:text-left"
          >
            <div className="relative inline-block mb-20 sm:mb-40">
              <Gift size={80} />
              <div className="absolute bottom-0 right-0 bg-primary-lighter w-52 h-52 -z-1" />
            </div>
            <h4 className="font-h4 mb-16">{t('STEPS_3_TITLE')}</h4>
            <p className="font-body3">{t('STEPS_3_DESCRIPTION')}</p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Steps;
